export const normalizeCategoriesDataFromQuery = (contentCategoriesBySite) => {
  const items = [];
  for (const category of contentCategoriesBySite) {
    items.push(category);

    for (const child of category.children) {
      items.push(child);
    }
  }

  return items;
};

export const showCategoryNameWithDepth = (category) => {
  if (category.depth === null) {
    return category.name;
  }

  const dash = '—';
  const categoryName = `${dash.repeat(category.depth + 1)} ${category.name}`;
  return categoryName;
};
